export default "__VITE_ASSET__0ec53019__"